import { safeStringify } from '../utils/utils.js';
import { captureException } from './sentryService.js';

const diiTracking = (eventName, eventPayload) => {
    try {
        if (typeof window._satellite !== 'undefined' && typeof window._satellite.track === 'function') {
            window._satellite.track(eventName, eventPayload);
        }
    }
    catch (error) {
        captureException({
            error,
            message: `Failed diiTracking on event ${eventName} with payload ${safeStringify(eventPayload)}`,
        });
    }
};
const braintreeTracking = (eventType, eventData) => {
    try {
        if (typeof window !== 'undefined' && typeof window.BraintreeTracking === 'function') {
            window.BraintreeTracking(eventType, eventData);
        }
    }
    catch (error) {
        captureException({
            error,
            message: `Failed braintreeTracking on event ${eventType} with data ${JSON.stringify(eventData)}`,
        });
    }
};
const applePayTracking = (eventType, eventData) => {
    try {
        if (typeof window !== 'undefined' && typeof window.ApplePayTracking === 'function') {
            window.ApplePayTracking(eventType, eventData);
        }
    }
    catch (error) {
        captureException({
            error,
            message: `Failed applePayTracking on event ${eventType} with data ${JSON.stringify(eventData)}`,
        });
    }
};
function isTrafficWrapper(value) {
    // eslint-disable-next-line no-prototype-builtins
    return value && value instanceof Object && value.hasOwnProperty('traffic');
}
function parseTrafficDataObject(trafficObjElement) {
    if (trafficObjElement && trafficObjElement.innerHTML) {
        try {
            const value = JSON.parse(trafficObjElement.innerHTML);
            if (isTrafficWrapper(value)) {
                return value;
            }
        }
        catch (error) {
            captureException({
                error,
                message: `Failed parsing trafficDataObject ${safeStringify(trafficObjElement.innerHTML)}`,
            });
        }
    }
    return { traffic: {} };
}
const registrationDataTrafficTracker = () => {
    const trafficObjElement = document.querySelector('#trafficDataObject');
    const trafficObjJson = parseTrafficDataObject(trafficObjElement);
    const setTrafficNotifications = (type, field, error) => {
        trafficObjJson.traffic.notifications = [{ type, field, error }];
    };
    const setTrackingAndUpdate = (eventName) => {
        if (trafficObjElement) {
            trafficObjElement.innerHTML = JSON.stringify(trafficObjJson);
            diiTracking(eventName);
        }
    };
    const cleanTrackingNotifications = () => {
        if (trafficObjElement) {
            trafficObjJson.traffic.notifications = [];
            trafficObjElement.innerHTML = JSON.stringify(trafficObjJson);
        }
    };
    const setTrackingErrors = (eventName, trafficNotifications) => {
        trafficObjJson.traffic.notifications = trafficNotifications;
        setTrackingAndUpdate(eventName);
    };
    return {
        setTrafficNotifications,
        setTrackingAndUpdate,
        cleanTrackingNotifications,
        setTrackingErrors,
    };
};

export { applePayTracking, braintreeTracking, registrationDataTrafficTracker };
//# sourceMappingURL=diiService.js.map
